/*
 * File: c:\Users\j.mazat\Desktop\mobybuy_front\src\Content\HeaderCart\HeaderCart.tsx
 * Project: c:\Users\j.mazat\Desktop\mobybuy_front
 * Created Date: Monday April 29th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 15th July 2024 04:28:56
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import Styles from 'Content/Header/HeaderIcons/HeaderIcons.module.css';
import RouterPathResolver from "Config/Router/RouterPathResolver";
import { FaRegHeart } from "react-icons/fa";
import { Tooltip } from '@mui/material';
import { Link } from "react-router-dom";
import translator from 'MultiLanguage/TranslationWrapper';
import { useInteractiveHeader } from 'Router/HeaderInteractionProvider';

function HeaderFav () {
    const InterractiveHeader = useInteractiveHeader();

    return (
        <Tooltip className={`${Styles.options}`} title={translator.decode("favorite.title")}>
            <Link className={`${Styles.iconLike}`} to={RouterPathResolver.routeFavorites.path}>
                <span className={`${Styles.infoBulle}`}>{InterractiveHeader.FavCount}</span>
                <FaRegHeart />
            </Link>
        </Tooltip>
    );
}

export default HeaderFav;
